import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

import scholarshipReducer from './private/redux/scholarship.reducer';

const persistConfig = {
  key: 'match',
  storage,
  whitelist: ['cms', 'scholarship']
};

const appReducer = combineReducers({
  scholarship: scholarshipReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
